module.exports = __webpack_public_path__ + "static/media/applePay-hero-2-mobile.6a23bc17.png";